var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { extractTileMapInfo } from "../formats/tms";
import { HTTPImageryProvider } from "./HTTPImageryProvider";
import { FileLoader } from "../loaders";
import { WebMercatorTilingScheme } from "../../math/tiling";
/**
 * Internal class used for handling loading from tile map service
 */
export class TMSImageryProvider extends HTTPImageryProvider {
    constructor(baseUrl, tileMap, options) {
        const tilingScheme = new WebMercatorTilingScheme(); // TODO: we can support other schemes by changing this
        super(tilingScheme, options);
        this.baseUrl = baseUrl;
        this.tileMap = tileMap;
    }
    static create(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield FileLoader.loadDocument(`${url}tilemapresource.xml`, {});
            if (!(response instanceof Document)) {
                throw new Error("Expected a document from the response");
            }
            const tileMap = extractTileMapInfo(url, response);
            const options = TMSImageryProvider.httpOptionsFromTileMapInfo(tileMap);
            return new TMSImageryProvider(url, tileMap, options);
        });
    }
    resolveTilePath(x, y, zoomLevel) {
        const tileDimensions = this._tilingScheme.getNumberOfYTilesAtLevel(zoomLevel) - 1;
        y = tileDimensions - y;
        const zoomHref = this.tileMap.tileSets.zoomHrefMap.get(zoomLevel);
        return `${this.baseUrl}${zoomHref}/${x}/${y}.${this.tileMap.tileFormat.extension}`;
    }
    resolveRequestOptions() {
        return undefined;
    }
    /**
     * Utility function for extracting an 'HTTPImageryProviderOptions' from a 'TileMapExtraction'
     * @param info
     */
    static httpOptionsFromTileMapInfo(info) {
        return {
            minLevel: info.tileSets.minLevel,
            maxLevel: info.tileSets.maxLevel,
            origin: info.origin,
            boundingBox: info.boundingBox,
        };
    }
}
